var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.cameraStarted)?_c('StreamBarcodeReader',{attrs:{"id":"stream"},on:{"decode":_vm.onDecode,"loaded":_vm.onLoaded}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }